<template>
<div>
	
	<div container-fluid class="mt-2 ">
		<div class="row">
			<div class="col-md-3"></div>
			<div _ngcontent-c2="" class="col-md-6 mb-4">
				<p class="header-login-text">Accedi alla tua Area Personale</p>
				<div class="bg-custom pt-0 mx-auto">
					<img class="img-fluid" src="../assets/spinosaLogo2.png" width="50" tabindex="0">
          <form @submit.prevent="handleSubmit">
            <div class="form-group input">

                <input type="text" placeholder="email" v-model="email" name="email" class="form-control" :class="{ 'is-invalid': submitted && !email }" />
                <div v-show="submitted && !email" class="invalid-feedback">email is required</div>
            </div><br/>
            <div class="form-group input">
                <input type="password" placeholder="Password" v-model="password" name="password" class="form-control" :class="{ 'is-invalid': submitted && !password }" />
                <div v-show="submitted && !password" class="invalid-feedback">Password is required</div>
            </div>

            <div class="form-group">

				<b-button @click="login" class="btn-login">Accedi</b-button>
				<p>{{error}}</p>
            </div>
        </form>
				</div>
				</div>
		</div>
	</div>
</div>
</template>
<script>
import axios from 'axios';
export default {
  name: 'login',
  components: {
  },
  data ()
  { 
  return {
    apiUrl: process.env.VUE_APP_ROOT_API,
    email: '',
		error: '',
    password: '',
	submitted: false,
  }},
// Request API.
methods: {
login: function () {
this.error = ''
axios.post(this.apiUrl + 'auth/local', { 'identifier': this.email,'password': this.password })
  .then(response => {
		// Handle success.
		if (response.status === 200) {
		this.submitted = true
		// eslint-disable-next-line
		//console.log('Well done!')
		// eslint-disable-next-line
		//console.log('User profile', response.data.user)
		// eslint-disable-next-line
		//console.log('User token', response.data.jwt)
		this.$store.dispatch('login', response.data.jwt)
		this.$router.push('conferimento')
		}
	})
  .catch(error => {
		if (error.status === 400) { this.error = 'Credenziali errate, riprova' }
		// Handle error.
		else {
		this.error = 'Si è verificato un errore'
		// eslint-disable-next-line
		console.log(error)
	}
  });
}
}
}
</script>

<style scoped>

	.login{
		max-width: 827px;
	}
	.login__card{
		padding: 40px 0 80px;
	}
	.login__logo{
		display: block;
		margin: 0 auto 42px;
	}

	.input {
		margin: 0 auto 24px;
		max-width: 268px;
	}
	.input label {
		display: block;
		font-size: 11pt;
		color: #90A1B5;
		width: 100%;
		font-weight: bold;
		padding-bottom: 8px;
	}
	.input input {
		background-clip: padding-box;
    background-color: transparent;
    border: solid rgba(0,0,0,.42);
    border-radius: 0;
    border-width: 0 0 1px;
    box-shadow: none;
    color: rgba(0,0,0,.87);
    display: block;
    font-size: 1rem;
    line-height: 1.5;
    padding: .375rem 0 calc(.375rem - 1px);
    width: 100%;
	}
	.input input:focus{
		outline: none;
	}
	.input--noWidth input {
		width: auto;
		max-width: 50px;
	}
	.text-center{
		margin-top: 16px;
		text-align: center;
	}
	.invalid-feedback{
		color:#cc0000;
		font-weight: bold;
	}
	.bg-custom {
    background-color: #f2f2f2;
    border-radius: 2px;
    box-shadow: 0 0 4px 0 rgba(0,0,0,.14), 0 3px 4px 0 rgba(0,0,0,.12), 0 1px 5px 0 rgba(0,0,0,.2);
		max-width: 350px;
    padding: 40px;
		margin-left: auto;
		margin-right: auto;
		
}
img {
    border-style: none;
    vertical-align: middle;
		width: 100%

}

.header-login-text {
    color: #330000;
    font-size: 22px;
    font-weight: 500;
}

.btn-login{
    background-color: #300;
    color: #fff;
}

.btn-login:disabled{
		background-color: rgba(0,0,0,.12);
    background-image: none;
    box-shadow: none;
    color: rgba(0,0,0,.26);
    opacity: 1;
}
</style>